<script lang="ts">
	import type { SbImage, SbLink } from '../types';
	import { getSbUrl } from '$lib/utils/storyblok/url';
	import Image from '../components/image.svelte';
	import { onMount } from 'svelte';
	import PageGrid16 from '../components/pageGrid16.svelte';
	import type { ISbStoryData } from '@storyblok/js';
	import Blok from '../blok.svelte';
	import { storyblok } from '$lib/state/storyblok.svelte';
	interface FooterData {
		content: Array<ISbStoryData['content']>;
		legal_links: Array<ISbStoryData<{ label: string; link: SbLink }>['content']>;
		social_links: Array<ISbStoryData<{ icon: SbImage; link: SbLink }>['content']>;
	}

	let footerData: Promise<FooterData>;

	onMount(async () => {
		async function getData() {
			const { data } = await storyblok.client.getStory(`globals/footer`);
			return data.story.content;
		}

		footerData = getData();
	});

	const currentYear = new Date().getFullYear();
</script>

<footer class="bg-white pb-5 pt-12 lg:pb-8 lg:pt-16">
	{#if footerData}
		{#await footerData}
			<div class="h-[33vh]"></div>
		{:then { content, legal_links, social_links }}
			<PageGrid16 margin>
				<div class="col-span-full">
					<div class="mb-12 flex w-full gap-x-16 gap-y-12 max-lg:flex-col lg:mb-20">
						{#each content as component}
							<Blok content={component} />
						{/each}
					</div>
					<div
						class="flex max-lg:flex-col-reverse max-lg:gap-y-8 lg:items-center lg:justify-between"
					>
						<div
							class="flex text-[12px] leading-[160%] text-brown-1 max-lg:flex-col-reverse max-lg:gap-y-2 lg:text-[14px]"
						>
							<div class="lg:mr-8">© {currentYear} Mill Industries Inc. All Rights Reserved.</div>
							<nav>
								<ul class="flex gap-x-4 lg:gap-x-8">
									{#each legal_links as { label, link }}
										<li><a href={getSbUrl(link)} target={link.target}>{label}</a></li>
									{/each}
								</ul>
							</nav>
						</div>
						<div class="flex items-center gap-x-5">
							{#each social_links as { icon, link }}
								<a href={getSbUrl(link)} target={link.target} class="block p-2">
									<Image
										src={icon.filename}
										alt={icon.alt}
										title={icon.title}
										width={24}
										height={24}
										class="h-6 w-6"
									/>
								</a>
							{/each}
						</div>
					</div>
				</div>
			</PageGrid16>
		{/await}
	{/if}
</footer>
